import { Dialog, DialogContent, makeStyles } from "@material-ui/core";
import withLayout from "components/HoC/withLayout";
import CancelPartA from "components/request-document/talent/CancelPartA";
import CancelPartB from "components/request-document/talent/CancelPartB";
import CancelRequestForm from "components/request-document/talent/CancelRequestForm";
import { cancelServiceId } from "libs/configs/constant";
import { CANCEL_STEP } from "libs/constant/VisaStep";
import useModalLoading from "libs/hooks/useModalLoading";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { getCancelRequestDoc, getOldDataSmartFormList, getPartFormList, getSmartFormList, readRequestDoc } from "redux/modules/cancelVisaSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0 10px",
  },
}));

function CancelVisaPage() {
  const dispatch = useDispatch();
  const history = useHistory()
  const { showReqeustDoc } = useSelector((state) => state.cancelVisa);
  const { personalID } = useSelector((state) => state.personal.detail);
  const [openRequest, setOpenRequest] = useState(false);
  const { showLoading, hideLoading } = useModalLoading();

  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const draftId = query.get('draftId');


  const handleRequestDocClsoe = () => {
    setOpenRequest(false)
  };
  const handleRequestDocSubmit = () => {
    dispatch(readRequestDoc(true));

  };

  useEffect(() => {
    showLoading();
    async function fetchData() {
      if (personalID) {
        await dispatch(getPartFormList({ smartserviceId: cancelServiceId, personalId: personalID }));
        const res = await dispatch(getSmartFormList({ personalId: personalID, isRequest: true }));
        await dispatch(getCancelRequestDoc({ smartserviceId: cancelServiceId, currSmartServiceId: res.payload?.smartserviceId }));
      }

      if (draftId) {
        const res = await dispatch(getOldDataSmartFormList({ personalId: personalID, draftId: draftId }));
        console.log(res);
      }
      hideLoading();

      if (!draftId) {
        setOpenRequest(!showReqeustDoc);
      }

    }
    fetchData();

  }, [dispatch, showReqeustDoc, personalID])


  return (
    <>

      <CancelVisaStep />

      <Dialog
        open={openRequest} s
        onClose={handleRequestDocClsoe}
        maxWidth="lg"
      >
        <DialogContent>
          <CancelRequestForm
            onCancel={handleRequestDocClsoe}
            onSubmit={handleRequestDocSubmit}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default withLayout(CancelVisaPage);

export { CancelVisaPage as AdminCancelVisaPage };

function CancelVisaStep() {
  const { step } = useSelector((state) => state.cancelVisa);
  switch (step) {
    case CANCEL_STEP.CANCEL_A:
      return <CancelPartA />;
    case CANCEL_STEP.CANCEL_B:
      return <CancelPartB />;
    default:
      return <CancelPartA />;
  }

  // return <></>;
}
